import * as _ from 'lodash';
import { SeverityLabelPipe } from '../pipes/SeverityLabelPipe';

export const SeverityEnum = Object.freeze({
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
});

export const makeSeverityDropdownOptions = () =>
    _.map(SeverityEnum, (value, key) => ({
        label: SeverityLabelPipe(key),
        value
    }));
